import { render } from "./global-settings.vue?vue&type=template&id=667b81a4"
import script from "./global-settings.vue?vue&type=script&lang=js"
export * from "./global-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__